import { get } from "../../utils/objectHelpers";

<if(input)>
    $ {
        const bannerURL = get(input, 'banner.URL', '');
        const bannerTitle = get(input, 'banner.title', '');
        const bannerWidth = get(input, 'banner.originalSize.width', null);
        const bannerHeight = get(input, 'banner.originalSize.height', null);
        const displayName = get(input, 'displayName.textSpans', []);
        const displayNameLink = get(input, 'displayName.action.URL', '');
        const displayNameTracking = JSON.stringify(get(input, 'displayName.action.trackingList.0', ''));
        const followNumber = get(input, 'followerDescription.textSpans', []);
        const feedbackPercentage = get(input, 'feedbackDescription.textSpans', []);
        const soldCount = get(input, 'soldDescription.textSpans', []);
        const storeLogoTitle = get(input, 'storeLogo.title', '');
        const storeLogoURL = get(input, 'storeLogo.URL', '');
        const storeLogoLink = get(input, 'storeLogo.action.URL', '');
        const storeLogoTracking = JSON.stringify(get(input, 'storeLogo.action.trackingList.0', ''));
        const aboutUs = get(input, 'aboutUs.textSpans', []);
        const descriptionText = get(input, 'description.textSpans.[0].text', '');
        const descriptionURLText = get(input, 'description.textSpans.[1].text', '');
        const descriptionURL = get(input, 'description.textSpans.[1].action.URL', '');
        const saveSellerAction = get(input, "saveSellerAction", {});
        const vacationMessage = get(input, 'message', {});
        const hasVacationMessage = Object.keys(vacationMessage).length == 0 ? false : true;
        const manageStoreUrl = get(input, 'manageStoreAction.action.URL', '');
        const manageStoreText = get(input, 'manageStoreAction.text', '');
    }
    <if(hasVacationMessage)>
        <str-status message=vacationMessage/>
    </if>
    <div class="str-header-wrap" key="str-header-wrap">
        <header class="str-header app-layout" data-testid="header">
            <!--====================
            // Manage store button
            ========================-->
            <if(!input.isSmall && manageStoreUrl !== '' && manageStoreText !== '')>
                <if(bannerURL !== '')>
                    <ebay-button href=manageStoreUrl class="str-header__manage-store">
                        ${manageStoreText}
                    </ebay-button>
                </if>
                <else>
                    <div class="str-header__manage-store-wrap">
                        <ebay-button href=manageStoreUrl class="str-header__manage-store" priority="primary">
                            ${manageStoreText}
                        </ebay-button>
                    </div>
                </else>
            </if>
            <!--====================
            // Banner image
            ========================-->
            <if(bannerURL !== '')>
                <if(bannerWidth >= 1000 && bannerHeight / bannerWidth <= .225)>
                    <div class="str-header__banner str-header__banner--large">
                        <img src=bannerURL alt=bannerTitle role="presentation" data-testid="hdr-banner-img"/>
                    </div>
                </if>
                <else>
                    <div class="str-header__banner str-header__banner--small">
                        <div style=`background-image: url(${bannerURL})`></div>
                        <img src=bannerURL alt=bannerTitle role="presentation" data-testid="hdr-banner-img"/>
                    </div>
                </else>
            </if>
            <!--====================
            // Header logo, info
            ========================-->
            <div class="str-header__info">
                <a class="str-header__logo" href=storeLogoLink data-track=storeLogoTracking>
                    <img class="str-header__logo--img" src=storeLogoURL alt=storeLogoTitle data-testid="hdr-logo"/>
                </a>
                <div class="str-header__details">
                    <div class="str-header__intro">
                        <h1 class="str-header__title large-section-title">
                            <a href=displayNameLink data-track=displayNameTracking>
                                <str-text-span textSpans=displayName />
                            </a>
                        </h1>
                        <div class="str-header__follow-container">
                            <div class="str-header__follow">
                                <follow-ebay
                                    fakeLink=true blackButton=true noText=true
                                    config=saveSellerAction
                                />
                            </div>
                        </div>
                    </div>
                    <div class="str-header__details--row"><str-text-span textSpans=followNumber/></div>
                    <div class="str-header__details--row"><str-text-span textSpans=feedbackPercentage/></div>
                    <div class="str-header__details--row"><str-text-span textSpans=soldCount/></div>
                </div>
                <if(descriptionText)>
                    <div class="str-header__about">
                        <div data-testid="hdr-about-title">
                            <str-text-span textSpans=aboutUs/>
                        </div>
                        <div class="str-header__description">
                            <p class="str-header__description--text" data-testid="hdr-about-text">${descriptionText}</p>
                            <a class="str-header__link" href=descriptionURL data-testid="hdr-learn-more">
                                ${descriptionURLText}
                            </a>
                        </div>
                    </div>
                </if>
            </div>
        </header>
        <!--====================
        // Sentinal needed for the sticky mini header (str-mini-header)
        ========================-->
        <div class="str-header__sticky-sentinel"></div>
    </div>
</if>
